import { useDataValue, useDataIsSubmitting } from 'Simple/Data.js'

export function useIsDisabled(props) {
  let is_acknowledged = useDataValue({
    context: 'selected',
    path: 'is_acknowledged',
    viewPath: props.viewPath,
  })
  let fee_acknowledged_by_user_id = useDataValue({
    context: 'selected',
    path: 'fee_acknowledged_by_user_id',
    viewPath: props.viewPath,
  })
  let is_submitting = useDataIsSubmitting({
    context: 'provider_accounts',
    viewPath: props.viewPath,
  })

  return is_submitting || !is_acknowledged || !fee_acknowledged_by_user_id
}
